import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewChild,
} from "@angular/core";
import { CustomSliderOptions } from "./custom-slider.models";
import { boostThemeEnum } from "../../services/page.service";
import { MatSliderModule } from "@angular/material/slider";
import { MatIconModule } from "@angular/material/icon";
import { FormsModule } from "@angular/forms";
import { AngularSvgIconModule } from "angular-svg-icon";
import { CommonModule } from "@angular/common";
import { AsteriskWithNumberComponent } from "../asterisk-with-number/asterisk-with-number.component";
import { StarWithNumberComponent } from "../star-with-number/star-with-number.component";
@Component({
  selector: "app-custom-slider",
  templateUrl: "./custom-slider.component.html",
  styleUrls: ["./custom-slider.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    MatSliderModule,
    MatIconModule,
    FormsModule,
    AngularSvgIconModule,
    AsteriskWithNumberComponent,
    StarWithNumberComponent,
  ],
})
export class CustomSliderComponent implements OnInit {
  @Input() options: CustomSliderOptions = {
    minValue: 1,
    maxValue: 10,
    sliderTrackColor: boostThemeEnum.none,
    customThumbColor: boostThemeEnum.none,
  };
  @Input() selectedValue: number = 0;
  @Output() selectedValueChange = new EventEmitter<number>();
  @ViewChild("slider") slider: any;

  ngOnInit(): void {
    if (this.options.minValue === 0) {
      this.options.minValue = 1;
    }
    if (!this.selectedValue) this.selectedValue = 0;
  }

  onValueChange(value: number) {
    this.selectedValue = value;
    this.selectedValueChange.emit(value);
  }

  toggleValue() {
    const newValue = this.selectedValue === 0 ? 1 : 0;
    this.onValueChange(newValue);
  }

  get thumbLeft(): string {
    const min = this.options.minValue; // forced >= 1 in ngOnInit
    const max = this.options.maxValue;
    const range = max - min || 1;

    // Score (icon) variant: inset the centre by the icon radius so that, combined
    // with translateX(-50%), the icon's edges stay within [0, 100%] at every value
    // (no transient horizontal overflow at the extremes).
    // Icon size (rem) mirrors the template's [iconSize]: star 2.25 / cloud 1.75 / zero 1.5.
    if (this.options.thumbIcon) {
      const f = Math.min(1, Math.max(0, (this.selectedValue - min) / range)); // clamp 0..1
      // Centre the icon on Material's tick-mark dots so value N sits on dot N.
      // `left` is resolved against the mat-slider padding box (its positioned
      // ancestor) and translateX(-50%) makes `left` the icon's centre, so this
      // matches Material's own dot position `2px + i*(cachedWidth-6)/(N-1)` where
      // `100%` == the mat-slider width. It is therefore INDEPENDENT of the
      // `.has-icon-thumb` track padding — the padding only insets the dots from the
      // container edges so the wide star/cloud icon doesn't clip at value 1 / 10.
      // Constants fitted to the rendered geometry and verified headlessly against
      // the actual dots across widths and --spacing-4 breakpoints.
      return `calc(5.9px + ${f} * (100% - 6px))`;
    }

    // Default asterisk variant — unchanged.
    if (this.selectedValue < 1) {
      return "-0.5%";
    } else if (this.selectedValue === 1) {
      return "1%";
    }
    return ((this.selectedValue - min) / range) * 100 + 1 + "%";
  }
}
